import React from 'react';

export interface DrinkBrandItem {
  id: string;
  name: string;
  brand: string;
  category: 'soda' | 'energy' | 'water' | 'juice' | 'coffee' | 'tea' | 'other';
  regions: ('US' | 'UK' | 'UA' | 'GLOBAL')[];
  defaultVolumeMl: number;
  caloriesPer100ml: number;
  sugarPer100ml: number;
  caffeinePer100ml: number;
  isEnergyDrink?: boolean;
  minAge?: number; // 18 for energy drinks
  primaryColor: string;
  badgeBgColor: string;
  descriptionEn?: string;
  descriptionUa?: string;
  logoType: string;
}

export const MASTER_DRINK_BRANDS: DrinkBrandItem[] = [
  {
    id: 'pepsi',
    name: 'Pepsi',
    brand: 'PepsiCo',
    category: 'soda',
    regions: ['US', 'UK', 'UA', 'GLOBAL'],
    defaultVolumeMl: 330,
    caloriesPer100ml: 41,
    sugarPer100ml: 11.0,
    caffeinePer100ml: 11.0,
    primaryColor: '#eb1438',
    badgeBgColor: '#002d72',
    descriptionEn: 'Classic refreshing cola with signature citrus note',
    descriptionUa: 'Класична освіжаюча кола з цитрусовим відтінком',
    logoType: 'pepsi'
  },
  {
    id: 'pepsi_zero',
    name: 'Pepsi Zero Sugar',
    brand: 'PepsiCo',
    category: 'soda',
    regions: ['US', 'UK', 'UA', 'GLOBAL'],
    defaultVolumeMl: 330,
    caloriesPer100ml: 0,
    sugarPer100ml: 0,
    caffeinePer100ml: 11.5,
    primaryColor: '#000000',
    badgeBgColor: '#000000',
    descriptionEn: 'Bold zero-calorie cola flavor with maximum taste',
    descriptionUa: 'Насичений смак коли без цукру та калорій',
    logoType: 'pepsi_zero'
  },
  {
    id: 'coca_cola',
    name: 'Coca-Cola Classic',
    brand: 'The Coca-Cola Company',
    category: 'soda',
    regions: ['US', 'UK', 'UA', 'GLOBAL'],
    defaultVolumeMl: 330,
    caloriesPer100ml: 42,
    sugarPer100ml: 10.6,
    caffeinePer100ml: 10.0,
    primaryColor: '#e41e2b',
    badgeBgColor: '#e41e2b',
    descriptionEn: 'The original iconic cola taste',
    descriptionUa: 'Оригінальний легендарний смак коли',
    logoType: 'coca_cola'
  },
  {
    id: 'mountain_dew',
    name: 'Mountain Dew',
    brand: 'PepsiCo',
    category: 'soda',
    regions: ['US', 'UK', 'UA', 'GLOBAL'],
    defaultVolumeMl: 355,
    caloriesPer100ml: 48,
    sugarPer100ml: 12.1,
    caffeinePer100ml: 15.2,
    primaryColor: '#22c55e',
    badgeBgColor: '#15803d',
    descriptionEn: 'Citrus-charged intense soda',
    descriptionUa: 'Інтенсивна цитрусова газована вода',
    logoType: 'mountain_dew'
  },
  {
    id: 'dr_pepper',
    name: 'Dr Pepper',
    brand: 'Keurig Dr Pepper',
    category: 'soda',
    regions: ['US', 'UK', 'UA', 'GLOBAL'],
    defaultVolumeMl: 330,
    caloriesPer100ml: 42,
    sugarPer100ml: 10.3,
    caffeinePer100ml: 11.5,
    primaryColor: '#711226',
    badgeBgColor: '#711226',
    descriptionEn: 'Unique blend of 23 flavors',
    descriptionUa: 'Унікальний мікс 23 смаків',
    logoType: 'dr_pepper'
  },
  {
    id: 'sprite',
    name: 'Sprite',
    brand: 'The Coca-Cola Company',
    category: 'soda',
    regions: ['US', 'UK', 'UA', 'GLOBAL'],
    defaultVolumeMl: 330,
    caloriesPer100ml: 39,
    sugarPer100ml: 9.1,
    caffeinePer100ml: 0,
    primaryColor: '#008b47',
    badgeBgColor: '#008b47',
    descriptionEn: 'Crisp lemon-lime caffeine-free soda',
    descriptionUa: 'Свіжий лимонно-лаймовий напій без кофеїну',
    logoType: 'sprite'
  },
  {
    id: 'fanta',
    name: 'Fanta Orange',
    brand: 'The Coca-Cola Company',
    category: 'soda',
    regions: ['US', 'UK', 'UA', 'GLOBAL'],
    defaultVolumeMl: 330,
    caloriesPer100ml: 43,
    sugarPer100ml: 10.4,
    caffeinePer100ml: 0,
    primaryColor: '#f37021',
    badgeBgColor: '#f37021',
    descriptionEn: 'Fruity sparkling orange soda',
    descriptionUa: 'Яскрава апельсинова газована вода',
    logoType: 'fanta'
  },
  {
    id: 'seven_up',
    name: '7UP',
    brand: 'PepsiCo',
    category: 'soda',
    regions: ['US', 'UK', 'UA', 'GLOBAL'],
    defaultVolumeMl: 330,
    caloriesPer100ml: 38,
    sugarPer100ml: 9.0,
    caffeinePer100ml: 0,
    primaryColor: '#00a859',
    badgeBgColor: '#00a859',
    descriptionEn: 'Refreshingly clear lemon-lime twist',
    descriptionUa: 'Освіжаючий лимонно-лаймовий напій',
    logoType: 'seven_up'
  },
  {
    id: 'schweppes',
    name: 'Schweppes Tonic',
    brand: 'Keurig Dr Pepper / Coca-Cola',
    category: 'soda',
    regions: ['US', 'UK', 'UA', 'GLOBAL'],
    defaultVolumeMl: 250,
    caloriesPer100ml: 34,
    sugarPer100ml: 8.3,
    caffeinePer100ml: 0,
    primaryColor: '#f0b323',
    badgeBgColor: '#1a1a1a',
    descriptionEn: 'Crisp quinine Indian Tonic Water',
    descriptionUa: 'Класичний індійський тонік з гірчинкою',
    logoType: 'schweppes'
  },

  // --- ENERGY DRINKS (18+ Age Restricted) ---
  {
    id: 'red_bull',
    name: 'Red Bull',
    brand: 'Red Bull GmbH',
    category: 'energy',
    isEnergyDrink: true,
    minAge: 18,
    regions: ['US', 'UK', 'UA', 'GLOBAL'],
    defaultVolumeMl: 250,
    caloriesPer100ml: 46,
    sugarPer100ml: 11.0,
    caffeinePer100ml: 32.0, // 80mg caffeine in 250ml
    primaryColor: '#cc0000',
    badgeBgColor: '#0d1f38',
    descriptionEn: 'Red Bull Energy Drink (Vitalizes Body and Mind). 18+',
    descriptionUa: 'Енергетичний напій Red Bull (Надає крила). 18+',
    logoType: 'red_bull'
  },
  {
    id: 'monster',
    name: 'Monster Energy',
    brand: 'Monster Beverage Corp',
    category: 'energy',
    isEnergyDrink: true,
    minAge: 18,
    regions: ['US', 'UK', 'UA', 'GLOBAL'],
    defaultVolumeMl: 500,
    caloriesPer100ml: 47,
    sugarPer100ml: 11.0,
    caffeinePer100ml: 32.0, // 160mg caffeine in 500ml
    primaryColor: '#39ff14',
    badgeBgColor: '#000000',
    descriptionEn: 'Unleash the Beast energy formula. 18+',
    descriptionUa: 'Енергетичний комплекс Monster Energy. 18+',
    logoType: 'monster'
  },
  {
    id: 'non_stop',
    name: 'Non Stop Original',
    brand: 'New Products Group',
    category: 'energy',
    isEnergyDrink: true,
    minAge: 18,
    regions: ['UA', 'GLOBAL'],
    defaultVolumeMl: 500,
    caloriesPer100ml: 45,
    sugarPer100ml: 10.8,
    caffeinePer100ml: 35.0, // 175mg caffeine in 500ml
    primaryColor: '#ef4444',
    badgeBgColor: '#0f172a',
    descriptionEn: 'High-octane energy drink with taurine & vitamins. 18+',
    descriptionUa: 'Потужний енергетичний напій з таурином та вітамінами. 18+',
    logoType: 'non_stop'
  },
  {
    id: 'burn',
    name: 'Burn Energy',
    brand: 'Monster Beverage Corp',
    category: 'energy',
    isEnergyDrink: true,
    minAge: 18,
    regions: ['UK', 'UA', 'GLOBAL'],
    defaultVolumeMl: 250,
    caloriesPer100ml: 48,
    sugarPer100ml: 11.5,
    caffeinePer100ml: 32.0, // 80mg caffeine in 250ml
    primaryColor: '#f97316',
    badgeBgColor: '#18181b',
    descriptionEn: 'Fiery taste & active energy boost. 18+',
    descriptionUa: 'Вогняний смак та запеклий енергетичний заряд. 18+',
    logoType: 'burn'
  },
  {
    id: 'rockstar',
    name: 'Rockstar Energy',
    brand: 'PepsiCo',
    category: 'energy',
    isEnergyDrink: true,
    minAge: 18,
    regions: ['US', 'UK', 'GLOBAL'],
    defaultVolumeMl: 500,
    caloriesPer100ml: 56,
    sugarPer100ml: 13.5,
    caffeinePer100ml: 32.0,
    primaryColor: '#eab308',
    badgeBgColor: '#18181b',
    descriptionEn: 'Party & performance energy formula. 18+',
    descriptionUa: 'Енергетичний напій Rockstar. 18+',
    logoType: 'rockstar'
  },
  {
    id: 'pit_bull',
    name: 'Pitbull Energy',
    brand: 'New Products Group',
    category: 'energy',
    isEnergyDrink: true,
    minAge: 18,
    regions: ['US', 'UK', 'UA', 'GLOBAL'],
    defaultVolumeMl: 250,
    caloriesPer100ml: 44,
    sugarPer100ml: 10.5,
    caffeinePer100ml: 32.0,
    primaryColor: '#ef4444',
    badgeBgColor: '#0f172a',
    descriptionEn: 'Pitbull Energy Drink (Unstoppable Drive). 18+',
    descriptionUa: 'Енергетичний напій Pitbull. 18+',
    logoType: 'pit_bull'
  },

  // --- LOCAL SPECIALTIES ---
  {
    id: 'zhivchik',
    name: 'Zhivchik Apple',
    brand: 'Obolon',
    category: 'soda',
    regions: ['UA'],
    defaultVolumeMl: 500,
    caloriesPer100ml: 38,
    sugarPer100ml: 9.3,
    caffeinePer100ml: 0,
    primaryColor: '#84cc16',
    badgeBgColor: '#fef08a',
    descriptionEn: 'Natural apple juice drink with echinacea extract',
    descriptionUa: 'Натуральний яблучний напій з екстрактом ехінацеї',
    logoType: 'zhivchik'
  },
  {
    id: 'kvas_taras',
    name: 'Kvas Taras',
    brand: 'Carlsberg Ukraine',
    category: 'soda',
    regions: ['UA'],
    defaultVolumeMl: 500,
    caloriesPer100ml: 28,
    sugarPer100ml: 6.8,
    caffeinePer100ml: 0,
    primaryColor: '#d97706',
    badgeBgColor: '#451a03',
    descriptionEn: 'Traditional fermented rye malt bread drink',
    descriptionUa: 'Традиційний хлібний квас житнього бродіння',
    logoType: 'kvas_taras'
  }
];

export function getDrinksForResidence(residence: string = 'US', allowEnergy18Plus: boolean = false): DrinkBrandItem[] {
  const normRes = residence.toUpperCase();
  return MASTER_DRINK_BRANDS.filter(item => {
    const isRegMatch = item.regions.includes(normRes as any) || item.regions.includes('GLOBAL');
    if (!isRegMatch) return false;
    if (item.isEnergyDrink && !allowEnergy18Plus) {
      // Still show in settings catalog with 18+ requirement badge, but filter or mark accordingly
      return true;
    }
    return true;
  });
}

export function getDefaultSelectedDrinkIds(residence: string = 'US'): string[] {
  const normRes = residence.toUpperCase();
  if (normRes === 'UA') {
    return ['pepsi', 'pepsi_zero', 'coca_cola', 'mountain_dew', 'non_stop', 'red_bull', 'burn', 'pit_bull', 'zhivchik', 'kvas_taras'];
  } else if (normRes === 'UK') {
    return ['coca_cola', 'pepsi', 'pepsi_zero', 'dr_pepper', 'fanta', 'red_bull', 'monster', 'burn', 'pit_bull', 'schweppes'];
  } else {
    // US or GLOBAL default
    return ['coca_cola', 'pepsi', 'pepsi_zero', 'mountain_dew', 'dr_pepper', 'red_bull', 'monster', 'pit_bull', 'sprite'];
  }
}

interface BrandLogoProps {
  logoType: string;
  name?: string;
  primaryColor?: string;
  className?: string;
  sizePx?: number;
}

export const BrandLogoCircle: React.FC<BrandLogoProps> = ({
  logoType,
  name = 'Drink',
  primaryColor = '#10b981',
  className = 'w-10 h-10',
  sizePx
}) => {
  const style = sizePx ? { width: `${sizePx}px`, height: `${sizePx}px` } : undefined;

  switch (logoType) {
    case 'coca_cola':
      return (
        <div 
          className={`relative rounded-full flex items-center justify-center overflow-hidden border border-red-600/30 shadow-sm shrink-0 bg-[#E41E2B] ${className}`}
          style={style}
          title="Coca-Cola"
        >
          <svg viewBox="0 0 100 100" className="w-full h-full p-1.5">
            <circle cx="50" cy="50" r="48" fill="#E41E2B" />
            <path d="M 15 55 Q 35 35 60 50 T 88 42 Q 65 65 35 50 T 15 55 Z" fill="#FFFFFF" opacity="0.95" />
            <text x="50" y="55" textAnchor="middle" fill="#FFFFFF" fontSize="22" fontWeight="900" fontFamily="serif" letterSpacing="-1">
              Coca-Cola
            </text>
          </svg>
        </div>
      );

    case 'pepsi':
      return (
        <div 
          className={`relative rounded-full flex items-center justify-center overflow-hidden border border-blue-900/40 shadow-sm shrink-0 bg-[#002D72] ${className}`}
          style={style}
          title="Pepsi"
        >
          <svg viewBox="0 0 100 100" className="w-full h-full p-1">
            <circle cx="50" cy="50" r="48" fill="#002D72" />
            {/* Pepsi Globe */}
            <circle cx="50" cy="50" r="40" fill="#FFFFFF" />
            {/* Top Red Crescent */}
            <path d="M 10 50 A 40 40 0 0 1 90 50 Q 50 25 10 50 Z" fill="#EB1438" />
            {/* Bottom Blue Crescent */}
            <path d="M 10 50 A 40 40 0 0 0 90 50 Q 50 75 10 50 Z" fill="#002D72" />
            {/* White Wave */}
            <path d="M 10 50 Q 50 25 90 50 Q 50 75 10 50 Z" fill="#FFFFFF" />
            <text x="50" y="53" textAnchor="middle" fill="#002D72" fontSize="13" fontWeight="900" fontFamily="sans-serif">
              PEPSI
            </text>
          </svg>
        </div>
      );

    case 'pepsi_zero':
      return (
        <div 
          className={`relative rounded-full flex items-center justify-center overflow-hidden border border-zinc-700 shadow-sm shrink-0 bg-black ${className}`}
          style={style}
          title="Pepsi Zero Sugar"
        >
          <svg viewBox="0 0 100 100" className="w-full h-full p-1">
            <circle cx="50" cy="50" r="48" fill="#000000" stroke="#333333" strokeWidth="2" />
            {/* Pepsi Globe centered */}
            <circle cx="50" cy="42" r="26" fill="#FFFFFF" />
            <path d="M 24 42 A 26 26 0 0 1 76 42 Q 50 26 24 42 Z" fill="#EB1438" />
            <path d="M 24 42 A 26 26 0 0 0 76 42 Q 50 58 24 42 Z" fill="#002D72" />
            <path d="M 24 42 Q 50 26 76 42 Q 50 58 24 42 Z" fill="#FFFFFF" />
            {/* ZERO Badge */}
            <rect x="20" y="72" width="60" height="18" rx="4" fill="#18181B" stroke="#EB1438" strokeWidth="1" />
            <text x="50" y="85" textAnchor="middle" fill="#FFFFFF" fontSize="10" fontWeight="900" fontFamily="sans-serif" letterSpacing="1.5">
              ZERO
            </text>
          </svg>
        </div>
      );

    case 'mountain_dew':
      return (
        <div 
          className={`relative rounded-full flex items-center justify-center overflow-hidden border border-green-700/50 shadow-sm shrink-0 bg-[#15803D] ${className}`}
          style={style}
          title="Mountain Dew"
        >
          <svg viewBox="0 0 100 100" className="w-full h-full p-1">
            <circle cx="50" cy="50" r="48" fill="#15803D" />
            <polygon points="12,20 88,10 78,85 22,78" fill="#22C55E" />
            <polygon points="18,30 82,22 72,75 28,70" fill="#E11D48" />
            <text x="50" y="47" textAnchor="middle" fill="#FFFFFF" fontSize="16" fontWeight="900" fontStyle="italic" fontFamily="sans-serif">
              MTN
            </text>
            <text x="50" y="65" textAnchor="middle" fill="#22C55E" fontSize="14" fontWeight="900" fontStyle="italic" fontFamily="sans-serif">
              DEW
            </text>
          </svg>
        </div>
      );

    case 'dr_pepper':
      return (
        <div 
          className={`relative rounded-full flex items-center justify-center overflow-hidden border border-amber-900/40 shadow-sm shrink-0 bg-[#711226] ${className}`}
          style={style}
          title="Dr Pepper"
        >
          <svg viewBox="0 0 100 100" className="w-full h-full p-1">
            <circle cx="50" cy="50" r="48" fill="#711226" />
            <ellipse cx="50" cy="50" rx="40" ry="26" fill="none" stroke="#FFFFFF" strokeWidth="3" />
            <text x="50" y="46" textAnchor="middle" fill="#FFFFFF" fontSize="15" fontWeight="900" fontFamily="serif">
              Dr
            </text>
            <text x="50" y="62" textAnchor="middle" fill="#FFFFFF" fontSize="13" fontWeight="900" fontFamily="serif">
              Pepper
            </text>
          </svg>
        </div>
      );

    case 'red_bull':
      return (
        <div 
          className={`relative rounded-full flex items-center justify-center overflow-hidden border border-blue-900/50 shadow-md shrink-0 bg-[#0D1F38] ${className}`}
          style={style}
          title="Red Bull (18+)"
        >
          <svg viewBox="0 0 100 100" className="w-full h-full p-1">
            <circle cx="50" cy="50" r="48" fill="#0D1F38" stroke="#94A3B8" strokeWidth="3" />
            {/* Yellow Sun */}
            <circle cx="50" cy="50" r="22" fill="#FFCC00" />
            {/* Left Bull */}
            <path d="M 18 55 C 28 45 38 48 44 50 C 40 55 30 58 18 55 Z" fill="#CC0000" />
            {/* Right Bull */}
            <path d="M 82 55 C 72 45 62 48 56 50 C 60 55 70 58 82 55 Z" fill="#CC0000" />
            <text x="50" y="82" textAnchor="middle" fill="#FFFFFF" fontSize="10" fontWeight="900" letterSpacing="1">
              RED BULL
            </text>
            <text x="82" y="24" textAnchor="middle" fill="#EF4444" fontSize="10" fontWeight="900">
              18+
            </text>
          </svg>
        </div>
      );

    case 'monster':
      return (
        <div 
          className={`relative rounded-full flex items-center justify-center overflow-hidden border border-emerald-500/50 shadow-md shrink-0 bg-black ${className}`}
          style={style}
          title="Monster Energy (18+)"
        >
          <svg viewBox="0 0 100 100" className="w-full h-full p-1.5">
            <circle cx="50" cy="50" r="48" fill="#000000" />
            {/* Claw M Scratch */}
            <path d="M 28 20 L 34 80 M 34 20 L 40 82 M 48 18 L 54 85 M 62 20 L 68 82 M 68 20 L 74 80" stroke="#39FF14" strokeWidth="6" strokeLinecap="round" />
            <text x="50" y="88" textAnchor="middle" fill="#39FF14" fontSize="8" fontWeight="900">
              MONSTER
            </text>
            <text x="82" y="24" textAnchor="middle" fill="#EF4444" fontSize="10" fontWeight="900">
              18+
            </text>
          </svg>
        </div>
      );

    case 'non_stop':
      return (
        <div 
          className={`relative rounded-full flex items-center justify-center overflow-hidden border border-red-500/40 shadow-sm shrink-0 bg-[#0F172A] ${className}`}
          style={style}
          title="Non Stop (18+)"
        >
          <svg viewBox="0 0 100 100" className="w-full h-full p-1">
            <circle cx="50" cy="50" r="48" fill="#0F172A" />
            {/* Lightning bolt */}
            <path d="M 52 15 L 34 48 L 50 48 L 44 85 L 68 42 L 52 42 Z" fill="#EF4444" stroke="#FFFFFF" strokeWidth="1.5" />
            <text x="50" y="70" textAnchor="middle" fill="#FFFFFF" fontSize="9" fontWeight="900">
              NON STOP
            </text>
            <text x="82" y="24" textAnchor="middle" fill="#EF4444" fontSize="10" fontWeight="900">
              18+
            </text>
          </svg>
        </div>
      );

    case 'burn':
      return (
        <div 
          className={`relative rounded-full flex items-center justify-center overflow-hidden border border-orange-500/40 shadow-sm shrink-0 bg-[#18181B] ${className}`}
          style={style}
          title="Burn (18+)"
        >
          <svg viewBox="0 0 100 100" className="w-full h-full p-1">
            <circle cx="50" cy="50" r="48" fill="#18181B" />
            {/* Flame */}
            <path d="M 50 15 C 65 35 70 50 65 65 C 60 78 40 80 35 65 C 32 55 38 45 42 40 C 42 50 48 55 52 50 C 58 42 50 25 50 15 Z" fill="#F97316" />
            <path d="M 50 35 C 58 48 60 58 56 68 C 52 75 42 75 38 68 C 36 62 40 54 44 50 C 44 56 48 60 50 56 C 54 50 50 40 50 35 Z" fill="#EF4444" />
            <text x="50" y="85" textAnchor="middle" fill="#F97316" fontSize="9" fontWeight="900">
              BURN
            </text>
            <text x="82" y="24" textAnchor="middle" fill="#EF4444" fontSize="10" fontWeight="900">
              18+
            </text>
          </svg>
        </div>
      );

    case 'sprite':
      return (
        <div 
          className={`relative rounded-full flex items-center justify-center overflow-hidden border border-emerald-600/30 shadow-sm shrink-0 bg-[#008B47] ${className}`}
          style={style}
          title="Sprite"
        >
          <svg viewBox="0 0 100 100" className="w-full h-full p-1">
            <circle cx="50" cy="50" r="48" fill="#008B47" />
            <polygon points="50,15 58,35 80,35 62,48 68,70 50,56 32,70 38,48 20,35 42,35" fill="#FFCC00" opacity="0.8" />
            <text x="50" y="56" textAnchor="middle" fill="#FFFFFF" fontSize="18" fontWeight="900" fontStyle="italic" fontFamily="sans-serif">
              Sprite
            </text>
          </svg>
        </div>
      );

    case 'fanta':
      return (
        <div 
          className={`relative rounded-full flex items-center justify-center overflow-hidden border border-orange-500/40 shadow-sm shrink-0 bg-[#F37021] ${className}`}
          style={style}
          title="Fanta"
        >
          <svg viewBox="0 0 100 100" className="w-full h-full p-1">
            <circle cx="50" cy="50" r="48" fill="#F37021" />
            <path d="M 50 18 Q 65 12 70 25 Q 55 30 50 18 Z" fill="#22C55E" />
            <ellipse cx="50" cy="55" rx="36" ry="24" fill="#002D72" />
            <text x="50" y="61" textAnchor="middle" fill="#FFFFFF" fontSize="16" fontWeight="900" fontFamily="sans-serif">
              FANTA
            </text>
          </svg>
        </div>
      );

    case 'seven_up':
      return (
        <div 
          className={`relative rounded-full flex items-center justify-center overflow-hidden border border-emerald-600/40 shadow-sm shrink-0 bg-[#00A859] ${className}`}
          style={style}
          title="7UP"
        >
          <svg viewBox="0 0 100 100" className="w-full h-full p-1">
            <circle cx="50" cy="50" r="48" fill="#00A859" />
            <circle cx="36" cy="52" r="14" fill="#EF4444" />
            <text x="50" y="62" textAnchor="middle" fill="#FFFFFF" fontSize="32" fontWeight="900">
              7
            </text>
            <text x="76" y="52" textAnchor="middle" fill="#FFFFFF" fontSize="14" fontWeight="900">
              UP
            </text>
          </svg>
        </div>
      );

    case 'schweppes':
      return (
        <div 
          className={`relative rounded-full flex items-center justify-center overflow-hidden border border-amber-400/40 shadow-sm shrink-0 bg-[#1A1A1A] ${className}`}
          style={style}
          title="Schweppes"
        >
          <svg viewBox="0 0 100 100" className="w-full h-full p-1">
            <circle cx="50" cy="50" r="48" fill="#1A1A1A" />
            <polygon points="50,15 80,35 80,70 50,88 20,70 20,35" fill="#F0B323" opacity="0.2" />
            <polygon points="50,22 72,38 72,65 50,78 28,65 28,38" fill="#EF4444" />
            <text x="50" y="55" textAnchor="middle" fill="#FFFFFF" fontSize="10" fontWeight="900" letterSpacing="0.5">
              SCHWEPPES
            </text>
          </svg>
        </div>
      );

    case 'rockstar':
      return (
        <div 
          className={`relative rounded-full flex items-center justify-center overflow-hidden border border-yellow-500/40 shadow-sm shrink-0 bg-[#18181B] ${className}`}
          style={style}
          title="Rockstar (18+)"
        >
          <svg viewBox="0 0 100 100" className="w-full h-full p-1">
            <circle cx="50" cy="50" r="48" fill="#18181B" />
            <polygon points="50,12 61,38 88,38 66,54 75,80 50,64 25,80 34,54 12,38 39,38" fill="#EAB308" />
            <text x="50" y="88" textAnchor="middle" fill="#EAB308" fontSize="8" fontWeight="900">
              ROCKSTAR
            </text>
            <text x="82" y="24" textAnchor="middle" fill="#EF4444" fontSize="10" fontWeight="900">
              18+
            </text>
          </svg>
        </div>
      );

    case 'pit_bull':
      return (
        <div 
          className={`relative rounded-full flex items-center justify-center overflow-hidden border border-zinc-700 shadow-sm shrink-0 bg-[#0F172A] ${className}`}
          style={style}
          title="Pit Bull (18+)"
        >
          <svg viewBox="0 0 100 100" className="w-full h-full p-1">
            <circle cx="50" cy="50" r="48" fill="#0F172A" />
            <circle cx="50" cy="45" r="28" fill="#EF4444" opacity="0.3" />
            <text x="50" y="52" textAnchor="middle" fill="#FFFFFF" fontSize="16" fontWeight="900">
              PITBULL
            </text>
            <text x="82" y="24" textAnchor="middle" fill="#EF4444" fontSize="10" fontWeight="900">
              18+
            </text>
          </svg>
        </div>
      );

    case 'zhivchik':
      return (
        <div 
          className={`relative rounded-full flex items-center justify-center overflow-hidden border border-lime-500/40 shadow-sm shrink-0 bg-[#FEF08A] ${className}`}
          style={style}
          title="Zhivchik"
        >
          <svg viewBox="0 0 100 100" className="w-full h-full p-1">
            <circle cx="50" cy="50" r="48" fill="#FEF08A" />
            {/* Apple Mascot */}
            <circle cx="50" cy="54" r="32" fill="#84CC16" />
            <path d="M 50 22 C 55 12 65 15 62 25 Z" fill="#15803D" />
            <circle cx="40" cy="48" r="4" fill="#FFFFFF" />
            <circle cx="60" cy="48" r="4" fill="#FFFFFF" />
            <circle cx="40" cy="48" r="2" fill="#000000" />
            <circle cx="60" cy="48" r="2" fill="#000000" />
            <path d="M 40 60 Q 50 68 60 60" fill="none" stroke="#FFFFFF" strokeWidth="3" strokeLinecap="round" />
            <text x="50" y="88" textAnchor="middle" fill="#15803D" fontSize="8" fontWeight="900">
              ЖИВЧИК
            </text>
          </svg>
        </div>
      );

    case 'kvas_taras':
      return (
        <div 
          className={`relative rounded-full flex items-center justify-center overflow-hidden border border-amber-800/50 shadow-sm shrink-0 bg-[#451A03] ${className}`}
          style={style}
          title="Kvas Taras"
        >
          <svg viewBox="0 0 100 100" className="w-full h-full p-1">
            <circle cx="50" cy="50" r="48" fill="#451A03" />
            <path d="M 20 50 C 20 20 80 20 80 50 C 80 80 20 80 20 50 Z" fill="#D97706" opacity="0.3" />
            <text x="50" y="46" textAnchor="middle" fill="#FEF3C7" fontSize="13" fontWeight="900" fontFamily="serif">
              КВАС
            </text>
            <text x="50" y="62" textAnchor="middle" fill="#F59E0B" fontSize="12" fontWeight="900" fontFamily="serif">
              ТАРАС
            </text>
          </svg>
        </div>
      );

    default:
      return (
        <div 
          className={`relative rounded-full flex items-center justify-center overflow-hidden border border-emerald-500/40 shadow-sm shrink-0 bg-emerald-500/20 text-emerald-500 ${className}`}
          style={{ ...style, backgroundColor: primaryColor ? `${primaryColor}22` : undefined }}
          title={name}
        >
          <span className="font-black text-xs uppercase">{name.substring(0, 2)}</span>
        </div>
      );
  }
};

export function calculateWaterLogNutrients(w: {
  amount_ml: number;
  beverage_type?: string;
  brand_id?: string;
  brand_name?: string;
  calories_kcal?: number;
  caffeine_mg?: number;
  sugar_g?: number;
  source_meal_id?: string;
}): { cal: number; caff: number; sugar: number } {
  if (w.source_meal_id) {
    return { cal: 0, caff: 0, sugar: 0 };
  }

  let cal: number | undefined = typeof w.calories_kcal === 'number' && !isNaN(w.calories_kcal) ? w.calories_kcal : undefined;
  let caff: number | undefined = typeof w.caffeine_mg === 'number' && !isNaN(w.caffeine_mg) ? w.caffeine_mg : undefined;
  let sugar: number | undefined = typeof w.sugar_g === 'number' && !isNaN(w.sugar_g) ? w.sugar_g : undefined;

  // If brand_id is specified and any value is missing, lookup brand
  if (w.brand_id && (cal === undefined || caff === undefined || sugar === undefined)) {
    const brand = MASTER_DRINK_BRANDS.find(b => b.id === w.brand_id);
    if (brand) {
      if (cal === undefined) cal = Math.round((w.amount_ml / 100) * brand.caloriesPer100ml);
      if (caff === undefined) caff = Math.round((w.amount_ml / 100) * brand.caffeinePer100ml);
      if (sugar === undefined) sugar = Math.round((w.amount_ml / 100) * brand.sugarPer100ml);
    }
  }

  const nameStr = `${w.brand_name || ''} ${w.beverage_type || ''}`.toLowerCase();

  // Pattern matching fallbacks if still undefined
  if (caff === undefined || cal === undefined || sugar === undefined) {
    if (w.beverage_type === 'coffee' || /\b(coffee|espresso|latte|cappuccino|americano|macchiato|mocha|cold brew)\b/i.test(nameStr) || /кава|еспресо|лате|латте|капучино|американо/i.test(nameStr)) {
      if (cal === undefined) cal = Math.round((w.amount_ml / 100) * 2);
      if (caff === undefined) caff = Math.round((w.amount_ml / 100) * 50);
      if (sugar === undefined) sugar = 0;
    } else if (w.beverage_type === 'tea' || /\b(tea|matcha|chai|green tea|black tea)\b/i.test(nameStr) || /чай|матча|матчя/i.test(nameStr)) {
      if (cal === undefined) cal = Math.round((w.amount_ml / 100) * 1);
      if (caff === undefined) caff = Math.round((w.amount_ml / 100) * 25);
      if (sugar === undefined) sugar = 0;
    } else if (/\b(pepsi zero|pepsi max|pepsi black|coca[- ]?cola zero|coke zero|diet coke|diet pepsi)\b/i.test(nameStr) || /пепсі зеро|кола зеро|дієтична кола|пепсі макс|пепсі блек/i.test(nameStr)) {
      if (cal === undefined) cal = 0;
      if (caff === undefined) caff = Math.round((w.amount_ml / 100) * 11.5);
      if (sugar === undefined) sugar = 0;
    } else if (/\b(pepsi|coca[- ]?cola|coke|cola|dr pepper|mountain dew)\b/i.test(nameStr) || /пепсі|кола|кока|маунтін/i.test(nameStr)) {
      const caffRate = /mountain dew|маунтін/i.test(nameStr) ? 15.2 : /dr pepper/i.test(nameStr) ? 11.5 : 11.0;
      if (cal === undefined) cal = Math.round((w.amount_ml / 100) * 41);
      if (caff === undefined) caff = Math.round((w.amount_ml / 100) * caffRate);
      if (sugar === undefined) sugar = Math.round((w.amount_ml / 100) * 11);
    } else if (/\b(energy|red bull|monster|burn|hell|pit bull|non stop|reign|rockstar)\b/i.test(nameStr) || /енерг|енергетик/i.test(nameStr)) {
      const caffRate = /non stop/i.test(nameStr) ? 35.0 : 32.0;
      if (cal === undefined) cal = Math.round((w.amount_ml / 100) * 45);
      if (caff === undefined) caff = Math.round((w.amount_ml / 100) * caffRate);
      if (sugar === undefined) sugar = Math.round((w.amount_ml / 100) * 11);
    }
  }

  return {
    cal: cal ?? 0,
    caff: caff ?? 0,
    sugar: sugar ?? 0
  };
}

